import React from "react";
import '../Form/FormTest.scss'
const Popups = props => {
  return (
    <div className="popup-box">
      <div className="box">
        {props.content}
      </div>
    </div>
  );
};
 
export default Popups;